import React from 'react'
import Img from 'gatsby-image'

export const NonceImg = (attrs) => {
  return <Img
    {...attrs}
    itemProp={`X-NONCE=${process.env.GATSBY_NONCE}`}
  />
}